const getCurrentDomain = () => {
    const { hostname } = window.location;
    const domainLevels = hostname.split('.');
    const [_, ...restDomainLevels] = domainLevels;
    if (domainLevels.length > 2)
        return `.${restDomainLevels.join('.')}`;
    return `.${domainLevels.join('.')}`;
};
const setRegionCookie = (cookieName, route) => {
    const domain = getCurrentDomain();
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    document.cookie = `${cookieName}=${route}; domain=${domain}; path=/; expires=${date.toUTCString()}`;
};
const groupLocationsByFirstLetter = (locations) => {
    const locationsGrouped = {};
    locations.forEach((location) => {
        const symbol = location.name[0].toUpperCase();
        if (locationsGrouped[symbol]) {
            locationsGrouped[symbol].push(location);
        }
        else {
            locationsGrouped[symbol] = [location];
        }
    });
    return locationsGrouped;
};

export { getCurrentDomain, groupLocationsByFirstLetter, setRegionCookie };
//# sourceMappingURL=index.js.map
